import React, { useState, useRef } from 'react';

let left_ = 0;
export default function Roadmap()
{
  const [ative, setActive] = useState('next');
  const [left, setleft] = useState(0);
  const ref = useRef(null);

  // const handleClick = (active) =>
  // {

  //   var maxScrollLeft = ref.current.scrollWidth - ref.current.clientWidth;
  //   setActive(active)
  //   if (active === "next") {
  //     left_ += 100
  //     if (left_ >= maxScrollLeft) {
  //       left_ = maxScrollLeft
  //     }
  //     ref.current.scroll({
  //       left: left_,
  //       behavior: 'smooth'
  //     })

  //   }
  //   else {
  //     left_ -= 100
  //     if (left_ <= 0) {
  //       left_ = 0
  //     }
  //     ref.current.scroll({

  //       left: left_,
  //       behavior: 'smooth'
  //     })
  //   }

  // };
  return (
    <section id="roadmap_" className="home-roadmap_">

      <div className="container ">
        <div className="sc-content wow fadeInUp">
          <div className="left">
            <div className="img_ bg_contain">
              <div className="img__ bg_contain"></div>
              <div className="img__ab bg_contain"></div>
            </div>
          </div>
          <div className="right">
            <div className="block_50  "></div>
            <h3 className='under_line'>Road Map</h3>
            <div className="block_10  "></div>
            <strong>Finally, it's a roadmap not a to-do list.</strong>
            <div className="block_10  "></div>
            <div className="block_10  "></div>
            <p>For us, preparing a road map is not necessary. The idea of the Rocket Raccoon is to develop the project equally, quickly. We' ve always listened to the community of the project, how to develop.Finally, the community is our road map</p>
            <div className="block_10  "></div>
            <div className="block_10  "></div>
            <div className='btn_w'>
              <button className="reset_btn  btn_dark btn_dark_lg " >JOIN US</button>
            </div>
            <div className="block_50  "></div>
          </div>

        </div>
      </div>

    </section>
  );
}
